import { Button, PageTitle } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { BtnGroup, BtnToolbar } from '@dec/shared';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { notificationSuccess } from '../../../core/toast';
import { FormPenalty } from '../components/FormPenalty';
import { createPenalty } from '../http';
import { type PenaltyForm, type PenaltyRequest } from '../types';

export const CreatePenalty = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const onSubmit = async (values: PenaltyForm) => {
    await createPenalty({
      taxId: values.tax?.id,
      accountTypeId: values.accountType?.id,
      penaltyType: values.penaltyType?.id,
      transactionTypeId: values.transactionType?.id,
      periodFrom: values.periodFrom,
      periodTo: values.periodTo,
      valueType: values.valueType?.id,
      taxPeriodicityTypeId: values.taxPeriodicityType?.id,
      value: values.valueType?.id === 'percentage' ? values.value / 100 : values.value
    } as PenaltyRequest);
    notificationSuccess(t('common.messages.savedSucessfully'));
    navigate('/penalties');
  };
  const onCancel = () => {
    navigate('/penalties');
  };

  return (
    <>
      <PageTitle title={t('taxpayer-current-account.label.penalty')} />
      <FormPenalty nameForm="formPenalty" onSubmit={onSubmit} />
      <BtnToolbar>
        <BtnGroup>
          <Button action={ButtonAction.cancel} variant="secondary" onClick={onCancel} />
        </BtnGroup>
        <BtnGroup>
          <Button action={ButtonAction.save} type="submit" variant="primary" form="formPenalty" />
        </BtnGroup>
      </BtnToolbar>
    </>
  );
};
